import "./WeekNav.css";

interface WeekNavProps {
	weekId: number | null;
	maxWeekId: number | null;
	onChange: (weekId: number) => void;
}

export const WeekNav = ({ weekId, maxWeekId, onChange }: WeekNavProps) => (
	<div className="week-nav" role="group" aria-label="Gameweek">
		<button className="week-nav-btn" aria-label="Previous gameweek" disabled={weekId == null || weekId <= 1} onClick={() => weekId != null && onChange(weekId - 1)}>
			<i className="ri-arrow-left-s-line" />
		</button>
		<span className="week-nav-label mono">{weekId != null ? `GW${weekId}` : "—"}</span>
		<button className="week-nav-btn" aria-label="Next gameweek" disabled={weekId == null || maxWeekId == null || weekId >= maxWeekId} onClick={() => weekId != null && onChange(weekId + 1)}>
			<i className="ri-arrow-right-s-line" />
		</button>
	</div>
);
